import __dev_log from "@/ts/__dev_log";

const profileImage = (url: string) => {
     __dev_log.log(url, url.startsWith(window.config.server.CDN_HOST))
     if(url.startsWith(window.config.server.CDN_HOST)) return url
     //return window.config.server.CDN_HOST + '/profile-image' + path;
     return 'https://cdn.wizzl.co/static/smile_default.png#' + url
}

export default profileImage;